<template>
    <div>
        <v-btn
            icon
            dark
            small
            color="white"
            class="close-btn close-btn-left d-none d-md-block"
            elevation="1"
            @click="closeHighlight">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <UtilsContent @close-action="closeHighlight">
            <template v-slot:header>
                <div class="d-flex flex-row justify-start align-center mb-4">
                    <img :src="indexImg" class="img-index mr-2" alt="" />
                    <div class="align-middle text-left line-height-100">
                        <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                            {{ $t('bookReading.marker') }}
                        </p>
                        <small class="font-size-12">Highlighting</small>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <div>
                    <v-row class="d-flex justify-start align-center flex-row ma-0">
                        <v-slide-group
                            v-model="model"
                            class="highlight-markerd"
                            mandatory
                        >
                            <v-slide-item v-for="(type, index) of highlightTypes" :key="index" class="mx-1">
                                <HighlightTypeItem
                                    :active="selectType === type.id"
                                    :value="type.value"
                                    :img="type.img"
                                    :type_id="type.id"
                                    :bgcolor="type.bgcolor"
                                    :bordercolor="type.bordercolor"
                                    @select="setSelectedType(type.id)"
                                />
                            </v-slide-item>
                        </v-slide-group>
                    </v-row>
                    <div
                        class="mt-4 d-flex flex-column chapters-container"
                        id="chapter-container"
                        v-if="highlightFiltered.length"
                    >
                        <HighlightItem
                            v-for="(hlg, index) of highlightFiltered"
                            :key="index"
                            :marker_data="hlg"
                            :value="index"
                        />
                    </div>
                    <div class="mt-4 d-flex flex-column chapters-container" v-else>
                        <span class="text-h6 text-center">
                            {{ $t('bookReading.without_highlights') }}
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:actions>
                <!-- <v-btn
                    color="#95afad"
                    fab
                    small
                    dark
                    class="mt-5 text--white"
                    @click="downScroll"
                    v-if="highlightFiltered.length"
                >
                    <v-icon dark class="text--white">mdi-arrow-down</v-icon>
                </v-btn> -->
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex'

import UtilsContent from '@/components/core/utils/UtilsContent.vue'
import HighlightItem from './items/HighlightItem.vue'
import HighlightTypeItem from './items/HighlightTypeItem.vue'

export default {
    components: {
        UtilsContent,
        HighlightItem,
        HighlightTypeItem,
    },
    computed: {
        ...mapState({
            bookHighlightData: (state) => state.bookReading.bookHighlightData,
            currentChapter: (state) => state.bookReading.currentChapter,
        }),
        highlightFiltered() {
            const vm = this
            return this.bookHighlightData.filter((el) => el.ordinalHighlightType === vm.selectType)
        },
    },
    data() {
        return {
            model: null,
            indexImg: require('@/assets/img/icons/new-reading/highlighting-purple.svg'),
            scrollPos: 0,
            selectType: 0,
            highlightTypes: [
                {
                    id: 0,
                    value: this.$t('bookReading.characters'),
                    color: '#97ed57',
                    bgcolor: '#E3FCEB',
                    bordercolor: '#3FB16D',
                    img: require('@/assets/img/icons/new-reading/highlight/icon-personajes.svg'),
                },
                {
                    id: 1,
                    value: this.$t('bookReading.actions'),
                    color: '#57d6ed',
                    bgcolor: '#E3F2FC',
                    bordercolor: '#33B2F5',
                    img: require('@/assets/img/icons/new-reading/highlight/icon-acciones.svg'),
                },
                {
                    id: 2,
                    value: this.$t('bookReading.vocabulary'),
                    color: '#ffdb39',
                    bgcolor: '#FBF5E4',
                    bordercolor: '#F4DFA0',
                    img: require('@/assets/img/icons/new-reading/highlight/icon-vocabulario.svg'),
                },
                {
                    id: 3,
                    value: this.$t('bookReading.places'),
                    color: '#ff44b9',
                    bgcolor: '#FEDFEF',
                    bordercolor: '#F2A0D0',
                    img: require('@/assets/img/icons/new-reading/highlight/icon-lugares.svg'),
                },
            ],
        }
    },
    methods: {
        downScroll() {
            const el = document.getElementById('chapter-container')
            el.scrollTop += 10
        },
        closeHighlight() {
            this.$emit('close-highlight')
        },
        setSelectedType(value) {
            this.selectType = value
        },
    },
}
</script>
<style>
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}
</style>
